module.exports = __webpack_public_path__ + "static/media/plus.b6b626ba.svg";